import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { GetChannelMembershipPreferences } from "../schemas/schemas_0";
export { $Command };
export class GetChannelMembershipPreferencesCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("ChimeMessagingService", "GetChannelMembershipPreferences", {})
    .n("ChimeSDKMessagingClient", "GetChannelMembershipPreferencesCommand")
    .sc(GetChannelMembershipPreferences)
    .build() {
}
